import { Tchek } from './tchek';

export interface FavoritePictureFilters {
  gamma: number;
  saturation: number;
  contrast: number;
  inversion: boolean;
  mirror: boolean;
}

export class Detail {
  id: string;
  pictureNumber: number;
  cameraName: string;
  tchek: Tchek;
  isSelected: boolean;
  path: string;
  filters: FavoritePictureFilters;
  totalPictures?: number;
  comparePtr: Detail;
  constructor() { }
}



// WEBPACK FOOTER //
// ./src/app/model/detail.ts